const typeMap = {
  '1': '门户',
  '2': '商城',
}
export {
  typeMap
}



// WEBPACK FOOTER //
// ./src/routes/carousel/constant.js